import { render, staticRenderFns } from "./message-menu.vue?vue&type=template&id=8a68b9a2&scoped=true&"
import script from "./message-menu.vue?vue&type=script&lang=js&"
export * from "./message-menu.vue?vue&type=script&lang=js&"
import style0 from "./message-menu.vue?vue&type=style&index=0&id=8a68b9a2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a68b9a2",
  null
  
)

export default component.exports